import once from "lodash/once";

export const loadGapi = once(async (api: string) => {
  const gapi = await loadGapiRoot();
  await new Promise((resolve, reject) =>
    gapi.load(api, {
      callback: resolve,
      onerror: reject,
    }),
  );
});

export const loadGapiRoot = once(() => {
  return new Promise<typeof gapi>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://apis.google.com/js/api.js";
    script.async = true;
    script.onerror = reject;
    script.onload = () => resolve(gapi);

    if (document.head) {
      document.head.appendChild(script);
    } else {
      reject(new TypeError("loadGapiRoot(): document.head isn't declared"));
    }
  });
});
